import {useTranslation} from 'react-i18next';
import HeaderWithIcons from '@components/app/HeaderWithIcons';
import {useEffect} from 'react';


export default function Routing() {
	const {t} = useTranslation();
	return (
		<div className="w-full h-full flex flex-col">
			<HeaderWithIcons backUrl="/" title={t('routing')}/>
			<iframe className="h-full"
			        src="https://neshan.org/maps/@36.288069,59.61936,13z,0p/places/4c638e5c7ef656a508ac0328613ace27"
			        allow="geolocation"/>
		</div>
	);
}
